import Actions from './ruleset-actions';
import Api from './ruleset-api';
import Collection from './ruleset-collection';
import Model from './ruleset-model';
import reducer from './ruleset-reducer';
import sagas from './ruleset-sagas';
import Selectors from './ruleset-selectors';

export default {
  Actions,
  Api,
  Collection,
  Model,
  name:       'ruleset',
  namespace:  'rulesets',
  pluralName: 'rulesets',
  reducer,
  sagas:      [sagas],
  Selectors,
};
